const state = {
};

const getters = {
};

const actions = {
    LoadFail2BanSettings({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('fail2ban_settings.load_fail2ban_settings', {
                entity_id: request_data,
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },
    SaveFail2BanSettings({ commit}, request_data ) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('fail2ban_settings.save_fail2ban_settings', {
                entity_id: request_data.entity_id,
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};